import { isEmptyObject } from "../../../lib/utils";

export const formValidator = (values, t) => {
  let formErrors = {};
  // debugger;
  // let Name = values["Name"];
  // let Description = values["Description"];

  // if (!Name) {
  //   formErrors = Object.assign(formErrors, {
  //     Name: t("datasets.create.datasetname_error"),
  //   });
  // }

  // if (!Description) {
  //   formErrors = Object.assign(formErrors, {
  //     Description: t("datasets.create.datasettitle_error"),
  //   });
  // }
  //console.log(formErrors)
  if (isEmptyObject(formErrors)) return undefined;
  //console.log("formErrors", formErrors);
  return formErrors;
};
